function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { loginObj } from '@/services/base';
import axios from 'axios';
import setupInterceptors from '@/services/setupInterceptors';
import tasks from '@/js/tasks';
var configuration = JSON.parse(process.env.VUE_APP_API_GTW_CONFIG);
var appApisGTW = null;
if (!configuration['data_quality']) {
  appApisGTW = axios.create({
    baseURL: 'http://localhost{PORT}'.replace('{PORT}', ':5000')
  });
} else {
  appApisGTW = axios.create({
    baseURL: process.env.VUE_APP_API_GTW.replace('{PORT}', ':8012')
  });
}
setupInterceptors(appApisGTW);
var headers = {
  'Content-Type': 'application/json'
};
var CONTROLLER_NAME = '/data_quality';
var DOMAIN_PROFILING = '/dataplex';
export default {
  getDimensions: function getDimensions() {
    var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var login = loginObj();
    var body = _objectSpread({
      login: login
    }, data);
    tasks.lockScreen.lock();
    return appApisGTW.post("".concat(CONTROLLER_NAME).concat(DOMAIN_PROFILING, "/dimensions"), body, {
      headers: headers
    }).then(function (response) {
      tasks.lockScreen.unlock();
      return response.data;
    });
  },
  createDimension: function createDimension() {
    var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var login = loginObj();
    var body = _objectSpread({
      login: login
    }, data);
    tasks.lockScreen.lock();
    return appApisGTW.post("".concat(CONTROLLER_NAME).concat(DOMAIN_PROFILING, "/dimensions/create"), body, {
      headers: headers
    }).then(function (response) {
      tasks.lockScreen.unlock();
      return response.data;
    });
  },
  updateDimension: function updateDimension() {
    var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var login = loginObj();
    var body = _objectSpread({
      login: login
    }, data);
    tasks.lockScreen.lock();
    return appApisGTW.post("".concat(CONTROLLER_NAME).concat(DOMAIN_PROFILING, "/dimensions/update"), body, {
      headers: headers
    }).then(function (response) {
      tasks.lockScreen.unlock();
      return response.data;
    });
  },
  removeDimension: function removeDimension() {
    var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var login = loginObj();
    var body = _objectSpread({
      login: login
    }, data);
    tasks.lockScreen.lock();
    return appApisGTW.post("".concat(CONTROLLER_NAME).concat(DOMAIN_PROFILING, "/dimensions/remove"), body, {
      headers: headers
    }).then(function (response) {
      tasks.lockScreen.unlock();
      return response.data;
    });
  },
  getExpectations: function getExpectations() {
    var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var login = loginObj();
    var body = _objectSpread({
      login: login
    }, data);
    tasks.lockScreen.lock();
    return appApisGTW.post("".concat(CONTROLLER_NAME).concat(DOMAIN_PROFILING, "/expectations"), body, {
      headers: headers
    }).then(function (response) {
      tasks.lockScreen.unlock();
      return response.data;
    });
  },
  createExpectation: function createExpectation() {
    var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var login = loginObj();
    var body = _objectSpread({
      login: login
    }, data);
    tasks.lockScreen.lock();
    return appApisGTW.post("".concat(CONTROLLER_NAME).concat(DOMAIN_PROFILING, "/expectations/create"), body, {
      headers: headers
    }).then(function (response) {
      tasks.lockScreen.unlock();
      return response.data;
    });
  },
  updateExpectation: function updateExpectation() {
    var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var login = loginObj();
    var body = _objectSpread({
      login: login
    }, data);
    tasks.lockScreen.lock();
    return appApisGTW.post("".concat(CONTROLLER_NAME).concat(DOMAIN_PROFILING, "/expectations/update"), body, {
      headers: headers
    }).then(function (response) {
      tasks.lockScreen.unlock();
      return response.data;
    });
  },
  removeExpectation: function removeExpectation() {
    var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var login = loginObj();
    var body = _objectSpread({
      login: login
    }, data);
    tasks.lockScreen.lock();
    return appApisGTW.post("".concat(CONTROLLER_NAME).concat(DOMAIN_PROFILING, "/expectations/remove"), body, {
      headers: headers
    }).then(function (response) {
      tasks.lockScreen.unlock();
      return response.data;
    });
  },
  getRules: function getRules() {
    var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var login = loginObj();
    var body = _objectSpread({
      login: login
    }, data);
    tasks.lockScreen.lock();
    return appApisGTW.post("".concat(CONTROLLER_NAME).concat(DOMAIN_PROFILING, "/rules"), body, {
      headers: headers
    }).then(function (response) {
      tasks.lockScreen.unlock();
      return response.data;
    });
  },
  createRule: function createRule() {
    var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var login = loginObj();
    var body = _objectSpread({
      login: login
    }, data);
    tasks.lockScreen.lock();
    return appApisGTW.post("".concat(CONTROLLER_NAME).concat(DOMAIN_PROFILING, "/rules/create"), body, {
      headers: headers
    }).then(function (response) {
      tasks.lockScreen.unlock();
      return response.data;
    });
  },
  updateRule: function updateRule() {
    var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var login = loginObj();
    var body = _objectSpread({
      login: login
    }, data);
    tasks.lockScreen.lock();
    return appApisGTW.post("".concat(CONTROLLER_NAME).concat(DOMAIN_PROFILING, "/rules/update"), body, {
      headers: headers
    }).then(function (response) {
      tasks.lockScreen.unlock();
      return response.data;
    });
  },
  removeRule: function removeRule() {
    var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var login = loginObj();
    var body = _objectSpread({
      login: login
    }, data);
    tasks.lockScreen.lock();
    return appApisGTW.post("".concat(CONTROLLER_NAME).concat(DOMAIN_PROFILING, "/rules/remove"), body, {
      headers: headers
    }).then(function (response) {
      tasks.lockScreen.unlock();
      return response.data;
    });
  },
  getProfilings: function getProfilings() {
    var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var login = loginObj();
    var body = _objectSpread({
      login: login
    }, data);
    tasks.lockScreen.lock();
    return appApisGTW.post("".concat(CONTROLLER_NAME).concat(DOMAIN_PROFILING, "/profilings"), body, {
      headers: headers
    }).then(function (response) {
      tasks.lockScreen.unlock();
      return response.data;
    });
  },
  getProfiling: function getProfiling() {
    var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var login = loginObj();
    var body = _objectSpread({
      login: login
    }, data);
    tasks.lockScreen.lock();
    return appApisGTW.post("".concat(CONTROLLER_NAME).concat(DOMAIN_PROFILING, "/profilings/get"), body, {
      headers: headers
    }).then(function (response) {
      tasks.lockScreen.unlock();
      return response.data;
    });
  },
  createProfiling: function createProfiling() {
    var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var login = loginObj();
    var body = _objectSpread({
      login: login
    }, data);
    tasks.lockScreen.lock();
    return appApisGTW.post("".concat(CONTROLLER_NAME).concat(DOMAIN_PROFILING, "/profilings/create"), body, {
      headers: headers
    }).then(function (response) {
      tasks.lockScreen.unlock();
      return response.data;
    });
  },
  createProfilingBulk: function createProfilingBulk() {
    var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var login = loginObj();
    var body = _objectSpread({
      login: login
    }, data);
    return appApisGTW.post("".concat(CONTROLLER_NAME).concat(DOMAIN_PROFILING, "/profilings/create"), body, {
      headers: headers
    }).then(function (response) {
      return response.data;
    });
  },
  updateProfiling: function updateProfiling() {
    var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var login = loginObj();
    var body = _objectSpread({
      login: login
    }, data);
    tasks.lockScreen.lock();
    return appApisGTW.post("".concat(CONTROLLER_NAME).concat(DOMAIN_PROFILING, "/profilings/update"), body, {
      headers: headers
    }).then(function (response) {
      tasks.lockScreen.unlock();
      return response.data;
    });
  },
  removeProfiling: function removeProfiling() {
    var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var login = loginObj();
    var body = _objectSpread({
      login: login
    }, data);
    tasks.lockScreen.lock();
    return appApisGTW.post("".concat(CONTROLLER_NAME).concat(DOMAIN_PROFILING, "/profilings/remove"), body, {
      headers: headers
    }).then(function (response) {
      tasks.lockScreen.unlock();
      return response.data;
    });
  },
  // Resumen de perfilamientos: última/próxima ejecución y columnas con % de
  // nulos sobre el umbral indicado (null_threshold)
  getProfilingsSummary: function getProfilingsSummary() {
    var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var login = loginObj();
    var body = _objectSpread({
      login: login
    }, data);
    tasks.lockScreen.lock();
    return appApisGTW.post("".concat(CONTROLLER_NAME).concat(DOMAIN_PROFILING, "/profilings/summary"), body, {
      headers: headers
    }).then(function (response) {
      tasks.lockScreen.unlock();
      return response.data;
    }).catch(function (err) {
      tasks.lockScreen.unlock();
      throw err;
    });
  },
  executeProfiling: function executeProfiling() {
    var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var login = loginObj();
    var body = _objectSpread({
      login: login
    }, data);
    tasks.lockScreen.lock();
    return appApisGTW.post("".concat(CONTROLLER_NAME).concat(DOMAIN_PROFILING, "/profilings/execute"), body, {
      headers: headers
    }).then(function (response) {
      tasks.lockScreen.unlock();
      return response.data;
    });
  },
  listProfilingExecutions: function listProfilingExecutions() {
    var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var login = loginObj();
    var body = _objectSpread({
      login: login
    }, data);
    tasks.lockScreen.lock();
    return appApisGTW.post("".concat(CONTROLLER_NAME).concat(DOMAIN_PROFILING, "/profilings/executions"), body, {
      headers: headers
    }).then(function (response) {
      tasks.lockScreen.unlock();
      return response.data;
    });
  },
  pingProfilingExecution: function pingProfilingExecution() {
    var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var login = loginObj();
    var body = _objectSpread({
      login: login
    }, data);
    tasks.lockScreen.lock();
    return appApisGTW.post("".concat(CONTROLLER_NAME).concat(DOMAIN_PROFILING, "/profilings/executions/ping"), body, {
      headers: headers
    }).then(function (response) {
      tasks.lockScreen.unlock();
      return response.data;
    });
  },
  getQualities: function getQualities() {
    var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var login = loginObj();
    var body = _objectSpread({
      login: login
    }, data);
    tasks.lockScreen.lock();
    return appApisGTW.post("".concat(CONTROLLER_NAME).concat(DOMAIN_PROFILING, "/qualities"), body, {
      headers: headers
    }).then(function (response) {
      tasks.lockScreen.unlock();
      return response.data;
    });
  },
  createQuality: function createQuality() {
    var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var login = loginObj();
    var body = _objectSpread({
      login: login
    }, data);
    tasks.lockScreen.lock();
    return appApisGTW.post("".concat(CONTROLLER_NAME).concat(DOMAIN_PROFILING, "/qualities/create"), body, {
      headers: headers
    }).then(function (response) {
      tasks.lockScreen.unlock();
      return response.data;
    });
  },
  getQuality: function getQuality() {
    var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var login = loginObj();
    var body = _objectSpread({
      login: login
    }, data);
    tasks.lockScreen.lock();
    return appApisGTW.post("".concat(CONTROLLER_NAME).concat(DOMAIN_PROFILING, "/qualities/get"), body, {
      headers: headers
    }).then(function (response) {
      tasks.lockScreen.unlock();
      return response.data;
    });
  },
  updateQuality: function updateQuality() {
    var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var login = loginObj();
    var body = _objectSpread({
      login: login
    }, data);
    tasks.lockScreen.lock();
    return appApisGTW.post("".concat(CONTROLLER_NAME).concat(DOMAIN_PROFILING, "/qualities/update"), body, {
      headers: headers
    }).then(function (response) {
      tasks.lockScreen.unlock();
      return response.data;
    });
  },
  removeQuality: function removeQuality() {
    var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var login = loginObj();
    var body = _objectSpread({
      login: login
    }, data);
    tasks.lockScreen.lock();
    return appApisGTW.post("".concat(CONTROLLER_NAME).concat(DOMAIN_PROFILING, "/qualities/remove"), body, {
      headers: headers
    }).then(function (response) {
      tasks.lockScreen.unlock();
      return response.data;
    });
  },
  executeQuality: function executeQuality() {
    var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var login = loginObj();
    var body = _objectSpread({
      login: login
    }, data);
    tasks.lockScreen.lock();
    return appApisGTW.post("".concat(CONTROLLER_NAME).concat(DOMAIN_PROFILING, "/qualities/execute"), body, {
      headers: headers
    }).then(function (response) {
      tasks.lockScreen.unlock();
      return response.data;
    });
  },
  listQualityExecutions: function listQualityExecutions() {
    var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var login = loginObj();
    var body = _objectSpread({
      login: login
    }, data);
    tasks.lockScreen.lock();
    return appApisGTW.post("".concat(CONTROLLER_NAME).concat(DOMAIN_PROFILING, "/qualities/executions"), body, {
      headers: headers
    }).then(function (response) {
      tasks.lockScreen.unlock();
      return response.data;
    });
  },
  pingQualityExecution: function pingQualityExecution() {
    var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var login = loginObj();
    var body = _objectSpread({
      login: login
    }, data);
    tasks.lockScreen.lock();
    return appApisGTW.post("".concat(CONTROLLER_NAME).concat(DOMAIN_PROFILING, "/qualities/executions/ping"), body, {
      headers: headers
    }).then(function (response) {
      tasks.lockScreen.unlock();
      return response.data;
    });
  },
  getProfilingsTable: function getProfilingsTable() {
    var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var login = loginObj();
    var body = _objectSpread({
      login: login
    }, data);
    tasks.lockScreen.lock();
    return appApisGTW.post("".concat(CONTROLLER_NAME).concat(DOMAIN_PROFILING, "/profilings/table"), body, {
      headers: headers
    }).then(function (response) {
      tasks.lockScreen.unlock();
      return response.data;
    });
  },
  getQualitiesTable: function getQualitiesTable() {
    var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var login = loginObj();
    var body = _objectSpread({
      login: login
    }, data);
    tasks.lockScreen.lock();
    return appApisGTW.post("".concat(CONTROLLER_NAME).concat(DOMAIN_PROFILING, "/qualities/table"), body, {
      headers: headers
    }).then(function (response) {
      tasks.lockScreen.unlock();
      return response.data;
    });
  }
};